import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["for"]

import { computed, ref } from 'vue';
import { FormKit, FormKitMessages } from '@formkit/vue';
import type { VueFormInputProps } from '@/composables/useFormInputData';
import RadioCardListMegaItem from './RadioCardListMegaItem.vue';
import RadioCardListComparisonItem from './RadioCardListComparisonItem.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'RadioCardList',
  props: /*@__PURE__*/_mergeModels({
    bindings: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;
const model = _useModel<string>(__props, "modelValue");

const inputRef = ref(null);

const isComparisonItem = computed(() => {
  return props.bindings?.options?.some((option: any) => option.amount);
});

const isSticky = computed(() => {
  return props.bindings?.outerClass?.includes('sticky');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(FormKit), _mergeProps({
    ref_key: "inputRef",
    ref: inputRef
  }, _ctx.bindings, {
    modelValue: model.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
    testId: _ctx.bindings.name || _ctx.bindings.label || _ctx.bindings.id,
    messagesClass: "hidden",
    type: "togglebuttons",
    enforced: "true"
  }), {
    label: _withCtx((context) => [
      (context.label)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            for: context.id,
            class: _normalizeClass(["mb-4", context.classes.label])
          }, _toDisplayString(context.label), 11, _hoisted_1))
        : _createCommentVNode("", true),
      _createVNode(_unref(FormKitMessages), {
        class: "!block",
        node: (inputRef.value as any)?.node
      }, null, 8, ["node"])
    ]),
    default: _withCtx((itemContext) => [
      (isComparisonItem.value && itemContext.option)
        ? (_openBlock(), _createBlock(RadioCardListComparisonItem, _mergeProps({ key: 0 }, itemContext.option, {
            isSticky: isSticky.value,
            isSelected: 
          itemContext.option.__original !== undefined
            ? itemContext.option.__original === model.value
            : itemContext.option.value === model.value
        ,
            frequencyLabel: _ctx.bindings.updatedFrequencyLabels ? _ctx.bindings.updatedFrequencyLabels[itemContext.index] : '',
            amountSymbol: _ctx.bindings.options?.[itemContext.index]?.amountSymbol ?? null,
            prorataSymbol: _ctx.bindings.options?.[itemContext.index]?.prorataSymbol ?? null,
            marginLeftForAmountSymbol: _ctx.bindings.marginLeftForAmountSymbol,
            removeSpaceAfterProRataSymbol: _ctx.bindings.removeSpaceAfterProRataSymbol
          }), null, 16, ["isSticky", "isSelected", "frequencyLabel", "amountSymbol", "prorataSymbol", "marginLeftForAmountSymbol", "removeSpaceAfterProRataSymbol"]))
        : (itemContext.option)
          ? (_openBlock(), _createBlock(RadioCardListMegaItem, _mergeProps({ key: 1 }, itemContext.option, {
              isSelected: 
          itemContext.option.__original !== undefined
            ? itemContext.option.__original === model.value
            : itemContext.option.value === model.value
        ,
              disabled: itemContext.disabled
            }), null, 16, ["isSelected", "disabled"]))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16, ["modelValue", "testId"]))
}
}

})